export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
    showHeaderOverflow: true,
  },
  {
    title: '',
    field: 'pdProcessDictStep',
    width: 100,
    visible: false,
    sortable: true,
  },
  {
    title: that.$l('table_label_pdProcessDictStep') || '工序',
    field: 'v_pdProcessDictStep',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techName') || '工艺',
    field: 'techName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techChargeUnit') || '计价单位',
    field: 'techChargeUnit',
    align: 'center',
    width: 150,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/biz',
        body: { dictType: 'techChargeUnit' },
        placeholder: that.$l('INDEX.tips_select_data') || '请选择...',
        filterable: true,
        clearable: true,
      },
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_labourCost') || '不含税工价',
    field: 'labourCost',
    align: 'center',
    width: 150,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 4,
        min: 0,
        step: 0.0001,
        'controls-position': 'right',
      },
    },
    formatter: ({ row }) => {
      const { labourCost: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_techDesc') || '工艺说明',
    field: 'techDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        clearable: true,
      },
    },
    showHeaderOverflow: true,
  },
]
